(function () {

  window.__QV_LOADED = true;

  const qs = (root, sel) => (root || document).querySelector(sel);
  const qsa = (sel, root = document) => root.querySelectorAll(sel);

  /* ============================================================
     QUICK VIEW CORE
  ============================================================ */

  function openQuickbuy(quickbuy) {
    quickbuy.hidden = false;
    quickbuy.style.display = "block";
    quickbuy.classList.add("is-open");
  }

  function closeQuickbuy(quickbuy) {
    quickbuy.classList.remove("is-open");
    quickbuy.hidden = true;
    quickbuy.style.display = "";
    const inner = qs(quickbuy, ".inner");
    if (inner) inner.innerHTML = "";
  }

  document.addEventListener("click", async (e) => {
    const btn = e.target.closest(".js-quick-view, [data-qv-trigger]");
    if (!btn) return;
    e.preventDefault();

    const card = btn.closest(".product-block");
    if (!card) return;

    let quickbuy = qs(card, ".quickbuy-container");
    if (!quickbuy) {
      quickbuy = document.createElement("div");
      quickbuy.className = "quickbuy-container";
      quickbuy.innerHTML = `<a href="#" class="close-detail">×</a><div class="inner"></div>`;
      card.appendChild(quickbuy);
    }

    const inner = qs(quickbuy, ".inner");
    const activeLi = qs(card, ".collection-tag-swatch li.active");
    const swatchUrl = activeLi?.dataset?.url;
    const fallbackUrl = qs(card, "a.product-link")?.getAttribute("href");
    const productUrl = swatchUrl || fallbackUrl;
    if (!productUrl) return;

    openQuickbuy(quickbuy);
    inner.innerHTML = `<div style="padding:20px">Loading…</div>`;

    try {
      const fetchUrl = `${productUrl}${productUrl.includes("?") ? "&" : "?"}sections=quick-view`;
      const res = await fetch(fetchUrl, { credentials: "same-origin" });
      const json = await res.json();
      if (!json["quick-view"]) throw "Section Missing";

      inner.innerHTML = json["quick-view"];

      requestAnimationFrame(() => {
        const productVariants = parseProductVariants(inner);
        productPageCard(inner);
        bindQtyButtons(inner);
        bindAddToCart(inner);
        const form = inner.querySelector("#product-form");
        if (form) updateQuickViewPricing(form, productVariants);
        itemAvailabilty(inner);
        activatePdpBuyQtyFromScope(inner);
      });

    } catch (err) {
      console.error(err);
      inner.innerHTML = `<div style="padding:20px">Error loading product</div>`;
    }
  });

  document.addEventListener("click", (e) => {
    const closeBtn = e.target.closest(".close-detail");
    if (!closeBtn) return;
    e.preventDefault();
    const quickbuy = closeBtn.closest(".quickbuy-container");
    if (quickbuy) closeQuickbuy(quickbuy);
  });

  /* ============================================================
     VARIANT SWITCHING (Size + Absorbency + Rise)
  ============================================================ */

  function activatePdpBuyQtyFromScope(scope) {
    if (!scope) return;
    scope.querySelectorAll("script").forEach((scriptEl) => {
      const code = scriptEl.textContent || "";
      if (!code.includes("variantPackMap") && !code.includes("variantPriceMap")) return;
      try {
        // Scripts inserted via innerHTML do not execute; re-run map definitions.
        // eslint-disable-next-line no-eval
        eval(code);
      } catch (err) {
        console.error("Failed to activate buy qty maps:", err);
      }
    });
    if (typeof window.initPdpBuyQtyPacks === "function") {
      window.initPdpBuyQtyPacks();
    }
  }

  function parseProductVariants(scope) {
    const jsonScript = scope.querySelector("script#quickViewJson");
    if (!jsonScript) return [];

    try {
      const match = jsonScript.textContent.match(
        /var\s+productVariants\s*=\s*(\[[\s\S]*?\]);/
      );
      if (match && match[1]) {
        return JSON.parse(match[1]);
      }
    } catch (e) {
      console.error("Failed to parse productVariants JSON:", e);
    }

    return [];
  }

  function hasVariantOptions(parent) {
    return !!(
      parent.querySelector(".Size-is-your-option") ||
      parent.querySelector(".Absorbency-is-your-option")
    );
  }

  function findMatchedVariant(variants, sizeEl, absEl, riseEl) {
    const size = sizeEl?.dataset.optionValue;
    const abs = absEl?.dataset.optionValue;
    const rise = riseEl?.dataset.optionValue;

    if (!size || !abs || !Array.isArray(variants)) return null;

    const hasThirdOption = variants.some((variant) => variant.option3);

    if (hasThirdOption) {
      if (!rise || !riseEl) return null;
      return variants.find(
        (variant) =>
          variant.option1 === size &&
          variant.option2 === abs &&
          variant.option3 === rise
      );
    }

    return variants.find(
      (variant) => variant.option1 === size && variant.option2 === abs
    );
  }

  function formatQuickViewRupees(cents) {
    return `₹ ${(Number(cents) / 100).toLocaleString("en-IN")}`;
  }

  function formatSaveDiscountLabel(variantComparePrice, variantPrice) {
    const compare = Number(variantComparePrice) || 0;
    const price = Number(variantPrice) || 0;
    if (compare <= price) return null;
    const discountPercentage = Math.round(((compare - price) / compare) * 100);
    const saveAmount = (compare - price) / 100;
    return `Save ₹ ${saveAmount} <span>(${discountPercentage}% off)</span>`;
  }

  function updateQuickViewPricing(parent, productVariants) {
    const sizeEl = parent.querySelector(".Size-is-your-option.active");
    const absEl = parent.querySelector(".Absorbency-is-your-option.active");
    const riseEl = parent.querySelector(".Rise-is-your-option.active");
    const salePriceEl = parent.querySelector("#sale-price");
    let comparePriceEl = parent.querySelector("#original-price");
    const discountEl = parent.querySelector(
      ".show-price-discount .product-price__item.price-label--sale"
    );
    const productPriceWrap = parent.querySelector("#product-price");
    const customVariantInput = parent.querySelector(".product_selected_variant_id");
    const atc = parent.querySelector("#add-to-cart-btn");
    const errEl = parent.querySelector(".selection-error-msg");

    if (!hasVariantOptions(parent)) {
      return !!customVariantInput?.value;
    }

    const matchedVariant = findMatchedVariant(
      productVariants,
      sizeEl,
      absEl,
      riseEl
    );

    if (!matchedVariant) {
      if (customVariantInput) customVariantInput.value = "";
      return false;
    }

    const variantPrice = Number(matchedVariant.price);
    const variantComparePrice = Number(matchedVariant.compare_at_price) || 0;
    const isAvailable = !!matchedVariant.available;

    if (customVariantInput) {
      customVariantInput.value = matchedVariant.id;
      customVariantInput.dispatchEvent(new Event("change", { bubbles: true }));
    }

    if (sizeEl) sizeEl.dataset.availabilty = isAvailable;
    if (absEl) absEl.dataset.availabilty = isAvailable;
    if (riseEl) riseEl.dataset.availabilty = isAvailable;

    const hasCompare = variantComparePrice > variantPrice;

    if (salePriceEl) {
      salePriceEl.textContent = formatQuickViewRupees(variantPrice);
      salePriceEl.setAttribute("item-price", variantPrice);
      salePriceEl.classList.add("sale-price");
      salePriceEl.classList.toggle("sale-price--discounted", hasCompare);
      salePriceEl.classList.toggle("sale-price--regular", !hasCompare);
      salePriceEl.setAttribute("data-discounted", hasCompare ? "true" : "false");
    }

    if (hasCompare) {
      const compareTxt = formatQuickViewRupees(variantComparePrice);

      if (comparePriceEl) {
        comparePriceEl.textContent = compareTxt;
        comparePriceEl.style.display = "";
        comparePriceEl.setAttribute("item-price", variantComparePrice);
      } else if (salePriceEl) {
        comparePriceEl = document.createElement("span");
        comparePriceEl.id = "original-price";
        comparePriceEl.setAttribute("item-price", variantComparePrice);
        comparePriceEl.textContent = compareTxt;
        salePriceEl.insertAdjacentElement("afterend", comparePriceEl);
      }

      if (discountEl) {
        const discountHtml = formatSaveDiscountLabel(
          variantComparePrice,
          variantPrice
        );
        discountEl.innerHTML = discountHtml || "";
        discountEl.style.display = discountHtml ? "" : "none";
      }
    } else {
      if (comparePriceEl) {
        comparePriceEl.style.display = "none";
        comparePriceEl.textContent = "";
      }
      if (discountEl) {
        discountEl.innerHTML = "";
        discountEl.style.display = "none";
      }
    }

    if (productPriceWrap) {
      productPriceWrap.classList.toggle("shown-compare-price", hasCompare);
    }

    if (isAvailable) {
      atc?.removeAttribute("disabled");
      if (errEl) errEl.classList.remove("show");
    }

    if (atc) {
      atc.setAttribute("data-price", variantPrice / 100);
      if (matchedVariant.sku) {
        atc.setAttribute("data-sku", matchedVariant.sku);
      }
    }

    return true;
  }

  function productPageCard(scope = document) {
    const productVariants = parseProductVariants(scope);

    qsa(
      ".Size-is-your-option, .Absorbency-is-your-option, .Rise-is-your-option",
      scope
    ).forEach((element) => {
      element.addEventListener("click", () => {
        const parent = element.closest("#product-form");
        if (!parent) return;

        element.parentElement
          .querySelectorAll(".new-varaint")
          .forEach((el) => el.classList.remove("active"));

        element.classList.add("active");
        updateQuickViewPricing(parent, productVariants);
        itemAvailabilty(scope);
        if (typeof window.updatePdpBuyQtyForVariant === "function") {
          const size = parent.querySelector(".Size-is-your-option.active");
          const abs = parent.querySelector(".Absorbency-is-your-option.active");
          const rise = parent.querySelector(".Rise-is-your-option.active");
          if (size && abs) {
            let key =
              size.getAttribute("data-option-value").replace(/\s+/g, "") +
              "_" +
              abs.getAttribute("data-option-value").replace(/\s+/g, "") +
              "_";
            if (rise) {
              key =
                size.getAttribute("data-option-value").replace(/\s+/g, "") +
                "_" +
                abs.getAttribute("data-option-value").replace(/\s+/g, "") +
                "_" +
                rise.getAttribute("data-option-value").replace(/\s+/g, "") +
                "_";
            }
            window.updatePdpBuyQtyForVariant(key);
          }
        }
      });
    });
  }

  /* ============================================================
     QUANTITY BUTTON HANDLER
  ============================================================ */

  function bindQtyButtons(scope = document) {
    function updateQuantity(action, fieldName) {
      const input = scope.querySelector(`input[name="${fieldName}"]`);
      if (!input) return;
      let current = parseInt(input.value) || 1;
      let min = parseInt(input.min) || 1;
      let max = parseInt(input.max) || 10;

      if (action === "plus" && current < max) current++;
      if (action === "minus" && current > min) current--;

      input.value = current;

      const mirror = scope.querySelector("#mahina_quantity");
      if (mirror) mirror.value = current;
    }

    qsa(".btnnumber", scope).forEach(btn => {
      btn.addEventListener("click", () => updateQuantity(btn.dataset.type, btn.dataset.field));
    });
  }

  /* ============================================================
     ADD TO CART HANDLER (AJAX)
  ============================================================ */

  function bindAddToCart(scope = document) {
  const form = scope.querySelector("#product-form");
  if (!form) return;

  form.addEventListener("submit", function(e) {
    e.preventDefault();

    const atc = this.querySelector("#add-to-cart-btn");
    const errEl = this.querySelector(".selection-error-msg");

    const size = this.querySelector(".Size-is-your-option.active");
    const abs = this.querySelector(".Absorbency-is-your-option.active");

    const hasSizeOpt = !!this.querySelector(".Size-is-your-option");
    const hasAbsOpt = !!this.querySelector(".Absorbency-is-your-option");

    if ((hasSizeOpt && !size) || (hasAbsOpt && !abs)) {
      let msg = "";
      if (hasSizeOpt && !size && hasAbsOpt && !abs) msg = "Please select size & absorbency";
      else if (hasSizeOpt && !size) msg = "Please select size";
      else if (hasAbsOpt && !abs) msg = "Please select absorbency";

      if (errEl) {
        errEl.textContent = msg;
        errEl.classList.add("show");
      }
      return;
    }

    const variantInput = this.querySelector(".product_selected_variant_id");
    let variantId = variantInput?.value;
    const qty = parseInt(scope.querySelector('input[name="quant[1]"]')?.value) || 1;

    if (!variantId) {
      const variants = parseProductVariants(scope);
      if (variants.length === 1) {
        variantId = String(variants[0].id);
        if (variantInput) variantInput.value = variantId;
      }
    }

    if (!variantId) {
      alert("Variant not selected");
      return;
    }

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
    })
    .then(r => r.json())
    .then(() => {
      atc.querySelector("span").textContent = "Added";
      setTimeout(() => {
        atc.querySelector("span").textContent = "Add To Cart";
      }, 2500);

      /* ================= SHOPFLO DRAWER OPEN ================= */
      setTimeout(() => {
        if (typeof handleFloCartBtn === "function") {
          handleFloCartBtn();
        }
      }, 2000);      
          

      /* ======================================================= */

      /* ================= QUICKVIEW AUTO CLOSE ================= */
      const quickbuy = scope.closest(".quickbuy-container");
      if (quickbuy) {
        setTimeout(() => {
          closeQuickbuy(quickbuy);
        }, 1200);
      }
      /* ======================================================= */

    })
    .catch(console.error);
  });
}

  /* ============================================================
     AVAILABILITY CHECK
  ============================================================ */

  function itemAvailabilty(scope = document) {
    const btn  = scope.querySelector("#add-to-cart-btn");
    const text = scope.querySelector("#add-to-cart-btn #button-text");

    if (!btn || !text) return;

    const form = scope.querySelector("#product-form");
    const hasSizeOpt = !!scope.querySelector(".Size-is-your-option");
    const hasAbsOpt = !!scope.querySelector(".Absorbency-is-your-option");

    if (form && !hasVariantOptions(form)) {
      const variants = parseProductVariants(scope);
      const variantInput = scope.querySelector(".product_selected_variant_id");
      const variant =
        variants.find((v) => String(v.id) === String(variantInput?.value)) ||
        variants[0];

      if (variant?.available) {
        btn.removeAttribute("disabled");
        btn.style.background = "#ED5431";
        text.textContent = "Add To Cart";
      } else {
        btn.setAttribute("disabled", "disabled");
        btn.style.background = "#ADADAD";
        text.textContent = "Out of Stock";
      }
      return;
    }

    const sizeEl = scope.querySelector(".Size-is-your-option.active");
    const absEl  = scope.querySelector(".Absorbency-is-your-option.active");

    if ((hasSizeOpt && !sizeEl) || (hasAbsOpt && !absEl)) return;

    const sizeAvailable = !hasSizeOpt || sizeEl.dataset.availabilty === "true";
    const absAvailable  = !hasAbsOpt || absEl.dataset.availabilty === "true";

    if (sizeAvailable && absAvailable) {
      btn.removeAttribute("disabled");
      btn.style.background = "#ED5431";
      text.textContent = "Add To Cart";
    } else {
      btn.setAttribute("disabled", "disabled");
      btn.style.background = "#ADADAD";
      text.textContent = "Out of Stock";
    }
  }
  

})();

(function() {
  // Open modal
  function openModal(targetId) {
    const mainModal = document.querySelector("#shopify-section-quick-view");
    const modalWrapper = document.querySelector(".quickview-modal-content");
    const closeModal = modalWrapper.querySelector(".close-quicl-view-detail")
    if (!modalWrapper) return;

    // Hide all children first
    Array.from(modalWrapper.children).forEach(child => {
      child.style.display = "none";
    });

    // Show only target
    const target = document.querySelector(targetId);
    if (!target) return;
    target.style.display = "block";

    // Show the modal wrapper
    modalWrapper.style.display = "block";
    closeModal.style.display = "block";
    modalWrapper.classList.add("is-open");
    mainModal.classList.add("quickview-is-open");
  }

  // Close modal
  function closeModal() {
    const modalWrapper = document.querySelector(".quickview-modal-content");
    const mainModal = document.querySelector("#shopify-section-quick-view");
    if (!modalWrapper) return;

    modalWrapper.style.display = "none";
    modalWrapper.classList.remove("is-open");
    mainModal.classList.remove("quickview-is-open");
    // Hide all children
    Array.from(modalWrapper.children).forEach(child => {
      child.style.display = "none";
    });
  }

  // Trigger click (works in normal page + quick view)
  document.addEventListener("click", function(e) {
    const trigger = e.target.closest("[data-modal-content]");
    if (!trigger) return;

    e.preventDefault();
    const targetId = trigger.dataset.modalContent;
    if (!targetId) return;

    openModal(targetId);
  });

  // Close modal if clicking anywhere with class .close-detail
  document.addEventListener("click", function(e) {
    if (e.target.closest(".close-quicl-view-detail")) {
      e.preventDefault();
      closeModal();
    }
  });
})();

